import React from 'react';
import { useTranslation } from 'react-i18next';
import './EmptyState.css';

const EmptyState = ({ name, icon = '📦' }) => {
  const { t } = useTranslation();
  const displayName = name || t('customerUi.emptyState.defaultName');

  return (
    <div className="empty-state-wrapper">
      <div className="empty-state-content">
        <div className="empty-state-icon">{icon}</div>
        <h2 className="empty-state-title">{t('customerUi.emptyState.title')}</h2>
        <p className="empty-state-text">{t('customerUi.emptyState.text', { name: displayName })}</p>
        <p className="empty-state-subtext">{t('customerUi.emptyState.hint')}</p>
      </div>
    </div>
  );
};

export default EmptyState;

